import type { AppSpotlightTabDefinition, AppSpotlightTabKey } from '../types';

interface TabNavigationProps {
  tabs: AppSpotlightTabDefinition[];
  activeTab: AppSpotlightTabKey;
  onTabChange: (tab: AppSpotlightTabKey) => void;
}

export function TabNavigation({
  tabs,
  activeTab,
  onTabChange,
}: TabNavigationProps) {
  return (
    <div className="flex items-center gap-1 border-b border-neutral-800 overflow-x-auto">
      {tabs.map(({ key, label, icon: Icon }) => (
        <button
          type="button"
          key={key}
          onClick={() => onTabChange(key)}
          className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px whitespace-nowrap ${
            activeTab === key
              ? 'border-teal-500 text-white'
              : 'border-transparent text-neutral-500 hover:text-neutral-300'
          }`}
        >
          <Icon className="size-4 fill-current" />
          {label}
        </button>
      ))}
    </div>
  );
}
